import { IComponentOptions, IController } from 'angular';
import './public-header.component.scss';

class PublicHeaderController implements IController {
  static $inject = [
  ];
  isAuth = false;
  isHeaderSmall = false;

  constructor() {
  }

  scrollHandler( event: { value: boolean } ) {
    this.isHeaderSmall = event.value;
  }
}

export const PublicHeaderComponent: IComponentOptions = {
  controller: PublicHeaderController,
  template: require('./public-header.component.html'),
  bindings: {
    isAuth: '<'
  }
};



// WEBPACK FOOTER //
// ./app/states/public/components/public-header/public-header.component.ts